import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'

// Modules
import metrics from './modules/metrics'
import myHome from './modules/my-home'
import improvements from './modules/improvements'
import routes from './modules/routes'
import serviceBasket from './modules/service-basket'

Vue.use(Vuex)

const Store = new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    state,
    modules: {
        metrics,
        myHome,
        improvements,
        routes,
        serviceBasket,
    },
    getters,
    actions,
    mutations,
})

export default Store
